//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("pscRequestsApi", PscRequestsApiFactory);

    PscRequestsApiFactory.$inject = ["apiClientFactory"];
    function PscRequestsApiFactory(apiClientFactory) {

        const routePrefix = "api/pscrequest/";

        return {
            AssistCheckRequestedByPartner: apiClientFactory.post(routePrefix + "AssistCheckRequestedByPartner/"),
            CreatePscRequest: apiClientFactory.post(routePrefix + "CreatePscRequest/"),
            MarkAsAccepted: apiClientFactory.post(routePrefix + "MarkAsAccepted/"),
            MarkAsReported: apiClientFactory.post(routePrefix + "MarkAsReported/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
            StartAssistInCheck: apiClientFactory.post(routePrefix + "StartAssistInCheck/"),
            StartAssistInWithCheck: apiClientFactory.post(routePrefix + "StartAssistInWithCheck/"),
            StartAssistInWithoutCheck: apiClientFactory.post(routePrefix + "StartAssistInWithoutCheck/"),
            SubmitPscRequestToNsa: apiClientFactory.post(routePrefix + "SubmitPscRequestToNsa/"),
            SubmitPscRequestToSo: apiClientFactory.post(routePrefix + "SubmitPscRequestToSo/"),
            SubmitValidatedPscRequestsToNsa: apiClientFactory.post(routePrefix + "SubmitValidatedPscRequestsToNsa/"),
            SubmitValidatedPscRequestToNsa: apiClientFactory.post(routePrefix + "SubmitValidatedPscRequestToNsa/"),
            SubmitValidatedPscRequestToSo: apiClientFactory.post(routePrefix + "SubmitValidatedPscRequestToSo/"),
            UpdateClearanceDates: apiClientFactory.post(routePrefix + "edit-clearance-dates/"),
        };
    }
})();
